// utils/logger.js
const LAA_isProduction = import.meta.env.PROD; // Check if the environment is production
const LAA_LOGGING_KEY = 'enable_logging'; // Key for manual override in localStorage
const LAA_logPrefix = 'LAA:';

const LAA_shouldLog = () => {
    const LAA_manualOverride = localStorage.getItem(LAA_LOGGING_KEY);
    if (LAA_manualOverride !== null) {
        return LAA_manualOverride === 'true';
    }
    return !LAA_isProduction; // Default: log in non-production environments
};

const LAA_logger = {
    alwayslog(...args) {
        console.log(LAA_logPrefix, ...args);
    },
    log(...args) {
        if (LAA_shouldLog()) {
            console.log(LAA_logPrefix, ...args);
        }
    },
    warn(...args) {
        if (LAA_shouldLog()) {
            console.warn(LAA_logPrefix, ...args);
        }
    },
    error(...args) {
        if (LAA_shouldLog()) {
            console.error(LAA_logPrefix, ...args);
        }
    },
    LAA_enableLogging() {
        localStorage.setItem(LAA_LOGGING_KEY, 'true');
    },
    LAA_disableLogging() {
        localStorage.setItem(LAA_LOGGING_KEY, 'false');
    },
};

export default LAA_logger;
